import { useEffect } from "react";
import { useMemoizedFn } from "ahooks";
const useWebWillAppear = (fn) => {
  const _fn = useMemoizedFn(fn);
  useEffect(() => {
    window.HiyaJSBridge.registerHandler("webWillAppear", _fn);
  }, []);
};
export {
  useWebWillAppear
};
